export default {
    "apiUrl": "http://yargogdps/api",
    "server": false,
    "url": "https://yargogdpsofficial.github.io/"
}